import api from "./api";

export default async function http(method, endpoint, data, type = "application/json") {
  let response = null;
  let statusCode = 0;

  try {
    if (method === "get") {
      response = await api.get(endpoint, data, { "Content-Type": type });
    } else if (method === "post") {
      response = await api.post(endpoint, data, { "Content-Type": type });
    } else if (method === "delete") {
      response = await api.delete(endpoint, data, { "Content-Type": type });
    } else if (method === "file") {
      response = await api.get(endpoint, { responseType: "blob" });
    }
    statusCode = 200;
  } catch (error) {
    if (error?.response) {
      if (process.env.NODE_ENV === "development") {
        console.log(error?.response?.data);
        console.log(error?.response?.status);
        console.log(error?.response?.headers);
      }
      statusCode = error?.response?.status;
    } else if (error?.request) {
      if (process.env.NODE_ENV === "development") {
        console.log(error?.request);
      }
    } else {
      if (process.env.NODE_ENV === "development") {
        console.log("Error", error?.message);
      }
    }

    if (error?.response?.status === 401) {
      response = { message: "Usuário não autenticado!" };
    } else if (error?.response?.data?.message) {
      response = { message: error?.response?.data?.message };
    } else {
      response = { message: "Ops, houve algum erro!" };
    }
  }
  if (process.env.NODE_ENV === "development") {
    console.log("HTTPSTATUS", statusCode);
  }

  return { statusCode: statusCode, response: response };
}
